import { AxiosError } from "axios";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { GetGruposAcessoRequest } from "../daos/read/get_grupos_acesso_request";
import { GetGruposAcessoResponse } from "../daos/read/get_grupos_acesso_response";
import { IAdministracaoService } from "./administracao_service";
import { DeleteGrupoAcessoRequest } from "../daos/delete/delete_grupo_acesso_request";
import { GestoresDAO, GetGestoresResponse } from "../daos/read/get_gestores_response";
import { GetGrupoAcessoRequest } from "../daos/read/get_grupo_acesso_request";
import { GetGrupoAcessoResponse } from "../daos/read/get_grupo_acesso_response";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { CreateUsuarioRequest, CreateUsuarioResponse } from "../daos/create/create_usuario";
import { UpdateUsuarioRequest, UpdateUsuarioResponse } from "../daos/update/update_usuario";
import { GetAllUsuarioRequest, GetAllUsuarioResponse } from "../daos/read/get_all_usuario";
import { GetUsuarioByIdRequest, GetUsuarioByIdResponse } from "../daos/read/get_usuario_by_id";
import { GetAllCentroCustoListaRequest, GetAllCentroCustoListaResponse } from "../../../comercial/data/daos/read/get_all_centro_custo_lista";
import { GetAllAtribuicaoGrupoRequest, GetAllAtribuicaoGrupoResponse } from "../daos/read/get_all_atribuicao_lista";
import { CreateGrupoAcessoRequest, CreateGrupoAcessoResponse } from "../daos/create/create_grupo_acesso";
import { UpdateGrupoAcessoRequest, UpdateGrupoAcessoResponse } from "../daos/update/update_grupo_acesso";
import { GetAllPermissaoGrupoAcessoRequest, GetAllPermissaoGrupoAcessoResponse } from "../daos/read/get_all_permissao_grupo_acesso";
import { CreatePermissaoGrupoAcessoRequest, CreatePermissaoGrupoAcessoResponse } from "../daos/create/create_permissao_grupo_acesso";
import { GetAtributoSistemaResponse, UpdateAtributoSistemaRequest } from "../daos/update/update_atributo_sistema";
import { GetSpaceUsedBDResponse } from "../daos/read/get_space_used_bd";
import { GetUsuariosTotalResponse } from "../daos/read/get_usuarios_total";

/**
 * AdministracaoService
 */

export class AdministracaoService implements IAdministracaoService {

  async getGruposAcesso(request: GetGruposAcessoRequest): Promise<GetGruposAcessoResponse> {
    try {
      const result = await axiosInstance({}).post(`/administracao/grupos-acesso`, request);
      const response = handleAxiosResponse<GetGruposAcessoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getGrupoAcesso(request: GetGrupoAcessoRequest): Promise<GetGrupoAcessoResponse> {
    try {
      const result = await axiosInstance({}).get(`/administracao/grupos-acesso/${request.idGrupoAcesso}`);
      const response = handleAxiosResponse<GetGrupoAcessoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteGrupoAcesso(request: DeleteGrupoAcessoRequest): Promise<void> {
    try {
      const result = await axiosInstance({}).get(`/administracao/grupos-acesso/delete/${request.idGruposAcesso}`);
      handleAxiosResponse<void>(result);
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getGestores(): Promise<GetGestoresResponse> {
    try {
      const result = await axiosInstance({}).get(`/administracao/grupos-acesso/gestores`);
      const response = handleAxiosResponse<GestoresDAO[]>(result);
      return { items: response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllAtribuicaoGrupoLista(request: GetAllAtribuicaoGrupoRequest): Promise<GetAllAtribuicaoGrupoResponse> {
    try {
      const result = await axiosInstance({}).post(`/administracao/atribuicao-grupo/getAll`, request);
      const response = handleAxiosResponse<GetAllAtribuicaoGrupoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createGrupoAcesso(request: CreateGrupoAcessoRequest): Promise<CreateGrupoAcessoResponse> {
    try {
      const result = await axiosInstance({}).post(`/administracao/grupos-acesso/create`, request);
      const response = handleAxiosResponse<CreateGrupoAcessoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateGrupoAcesso(request: UpdateGrupoAcessoRequest): Promise<UpdateGrupoAcessoResponse> {
    try {
      const result = await axiosInstance({}).post(`/administracao/grupos-acesso/update`, request);
      const response = handleAxiosResponse<UpdateGrupoAcessoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllPermissaoGrupoAcesso(request: GetAllPermissaoGrupoAcessoRequest): Promise<GetAllPermissaoGrupoAcessoResponse> {
    try {
      const result = await axiosInstance({}).get(`/administracao/grupos-acesso/permissoes/${request.idGrupoAcesso}`);
      const response = handleAxiosResponse<GetAllPermissaoGrupoAcessoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async createPermissaoGrupoAcesso(request: CreatePermissaoGrupoAcessoRequest): Promise<CreatePermissaoGrupoAcessoResponse> {
    try {
      const result = await axiosInstance({}).post(`/administracao/grupos-acesso/permissoes/create`, request);
      const response = handleAxiosResponse<CreatePermissaoGrupoAcessoResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateAtributoSistema(request: UpdateAtributoSistemaRequest): Promise<void> {
    try {
      const result = await axiosInstance({}).post(`/administracao/atributos-sistema/update`, request);
      //const response = handleAxiosResponse<void>(result);
      handleAxiosResponse<void>(result);
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAtributoSistema(): Promise<GetAtributoSistemaResponse> {
    try {
      const result = await axiosInstance({}).get(`/administracao/atributos-sistema/get`);
      const response = handleAxiosResponse<GetAtributoSistemaResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getSpaceUsedBD(): Promise<GetSpaceUsedBDResponse> {
    try {
      const result = await axiosInstance({}).get(`/administracao/atributos-sistema/espaco`);
      const response = handleAxiosResponse<GetSpaceUsedBDResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }


  //#region USUARIOS

  async createUsuario(request: CreateUsuarioRequest): Promise<CreateUsuarioResponse> {
    try {
      const result = await axiosInstance({}).post(`/usuario/create-usuario`, request);
      const response = handleAxiosResponse<CreateUsuarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async updateUsuario(request: UpdateUsuarioRequest): Promise<UpdateUsuarioResponse> {
    try {
      const result = await axiosInstance({}).post(`/usuario/update-usuario`, request);
      const response = handleAxiosResponse<UpdateUsuarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllUsuariosLista(request: GetAllUsuarioRequest): Promise<GetAllUsuarioResponse> {
    try {
      const result = await axiosInstance({}).post(`/usuario/getall/lista`, request);
      const response = handleAxiosResponse<GetAllUsuarioResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getUsuariosTotal(): Promise<GetUsuariosTotalResponse> {
    try {
      const result = await axiosInstance({}).get(`/usuario/get/total`);
      const response = handleAxiosResponse<GetUsuariosTotalResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async deleteUsuario(idUsuario: number): Promise<void> {
    try {
      const result = await axiosInstance({}).get(`/usuario/delete-usuario/${idUsuario}`);
      handleAxiosResponse<void>(result);
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getUsuarioById(request: GetUsuarioByIdRequest): Promise<GetUsuarioByIdResponse> {
    try {
      const result = await axiosInstance({}).get(`/usuario/${request.idUsuario}`);
      const response = handleAxiosResponse<GetUsuarioByIdResponse>(result);
      return response;
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async bloqueioUsuarioById(idUsuario: number): Promise<void> {
    try {
      const result = await axiosInstance({}).get(`/usuario/bloqueio-usuario/${idUsuario}`);
      handleAxiosResponse<void>(result);
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  }

  async getAllCentroCustoRestricaoUsuario(request: GetAllCentroCustoListaRequest): Promise<GetAllCentroCustoListaResponse> {
    try {
      const result = await axiosInstance({}).post(`/comercial/centrocustos/lista`, request);
      const response = handleAxiosResponse<GetAllCentroCustoListaResponse>(result);
      return { ...response };
    } catch (error: unknown) {
      if (typeof error === "string") {
        throw new Error(error);
      } else if (isBaseError(error)) {
        throw toBaseError(error);
      } else if (error instanceof AxiosError) {
        throw new Error(error.message);
      } else if (error instanceof Error) {
        throw error;
      } else {
        throw new Error("Falha ao executar requisição!");
      }
    }
  };

  //#endregion
}
